// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all 0.2s ease-in-out;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Global scrollbar styling - applies to all scrollable areas (SQL editor, modals, lists, etc.) */
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

*::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

*::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

*::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

*::-webkit-scrollbar-thumb:active {
  background: #64748b;
}

/* CodeMirror SQL editor scroller - ensure scrollbar is always visible */
.cm-editor .cm-scroller {
  overflow-y: scroll !important;
  overflow-x: auto !important;
  scrollbar-gutter: stable;
}

.cm-editor .cm-scroller::-webkit-scrollbar {
  width: 8px;
}

.cm-editor .cm-scroller::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 4px;
}

.cm-editor .cm-scroller::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* DynamicTable: scrollbars only when content overflows */
.dynamic-table-scroll {
  overflow-x: auto !important;
  overflow-y: auto !important;
}
.dynamic-table-scroll::-webkit-scrollbar {
  width: 10px !important;
  height: 12px !important;
}
.dynamic-table-scroll::-webkit-scrollbar-track {
  background: #e2e8f0 !important;
  border-radius: 4px;
}
.dynamic-table-scroll::-webkit-scrollbar-thumb {
  background: #94a3b8 !important;
  border-radius: 4px;
}
.dynamic-table-scroll::-webkit-scrollbar-thumb:hover {
  background: #64748b !important;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE;aACW;AACb;;AAEA,iGAAiG;AACjG;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transition: all 0.2s ease-in-out;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Global scrollbar styling - applies to all scrollable areas (SQL editor, modals, lists, etc.) */\n*::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n*::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n*::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n*::-webkit-scrollbar-thumb:active {\n  background: #64748b;\n}\n\n/* CodeMirror SQL editor scroller - ensure scrollbar is always visible */\n.cm-editor .cm-scroller {\n  overflow-y: scroll !important;\n  overflow-x: auto !important;\n  scrollbar-gutter: stable;\n}\n\n.cm-editor .cm-scroller::-webkit-scrollbar {\n  width: 8px;\n}\n\n.cm-editor .cm-scroller::-webkit-scrollbar-track {\n  background: #f8fafc;\n  border-radius: 4px;\n}\n\n.cm-editor .cm-scroller::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* DynamicTable: scrollbars only when content overflows */\n.dynamic-table-scroll {\n  overflow-x: auto !important;\n  overflow-y: auto !important;\n}\n.dynamic-table-scroll::-webkit-scrollbar {\n  width: 10px !important;\n  height: 12px !important;\n}\n.dynamic-table-scroll::-webkit-scrollbar-track {\n  background: #e2e8f0 !important;\n  border-radius: 4px;\n}\n.dynamic-table-scroll::-webkit-scrollbar-thumb {\n  background: #94a3b8 !important;\n  border-radius: 4px;\n}\n.dynamic-table-scroll::-webkit-scrollbar-thumb:hover {\n  background: #64748b !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
